import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '@utils/sharedUtils';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useNavigate } from 'react-router-dom';
import { setAuditLog } from '@store/reducers/userSlice';
import DeviceDetailsModal from './AuditLogDetailsModal';

interface NotificationData {
    notificationDate: string;
    message: string;
    status?: string;
}

type AuditLog = {
    action: string;
    model_type: string;
    user_id: string;
    host: string;
    timestamp: string;
};

interface AuditLogList {
    uuid: string;
    action: string;
    model_id: string;
    model_type: string;
    user_id: string;
    properties: Record<string, any>;
    host: string;
    timestamp: string;
    time?: string;
}

interface AuditLogTableProps {
    data: AuditLogList[];
    header: any[];
}

const AuditLogDisplay = ({ data, header }: AuditLogTableProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loggedInUserRole = useAppSelector(
        (state) => state.login.loggedInUserRole
    );
    const [showModal, setShowModal] = useState(false);

    if (data.length === 0) {
        return (
            <div className="card">
                <div className="card-datatable table-responsive">
                    <table className="datatables-users table">
                        <thead className="border-bottom">
                            <tr>
                                {header.map((notification) => (
                                    <th
                                        className="font-semibold text-black text-base border-none !normal-case"
                                        key={notification.id}
                                    >
                                        {capitalizeFirstLetter(
                                            notification.title
                                        )}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="text-center ">
                                <td colSpan={header.length + 1}>
                                    {t('user_management.user_table.no_data')}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    let keys = Object.keys(data[0]).filter(
        (key) =>
            key !== 'uuid' &&
            key != 'model_id' &&
            key != 'time' &&
            key != 'properties'
    );

    const handleRowClick = async (logList: any) => {
        try {
            dispatch(setAuditLog(logList));
            setShowModal(true);
        } catch (error: any) {
            console.log('error', error);
        }
    };

    return (
        <>
            <div className="card rounded-2xl mt-5">
                <div className="card-datatable table-responsive">
                    <table className="datatables-users table">
                        <thead className="border-bottom">
                            <tr>
                                <th className=""></th>
                                {header.map((list) => (
                                    <th
                                        key={list.id}
                                        className={`text-black text-base font-semibold py-4 !normal-case
                                                    ${
                                                        list.title.toLowerCase() ===
                                                        'action'
                                                            ? ''
                                                            : ''
                                                    }
                                                    `}
                                    >
                                        {capitalizeFirstLetter(list.title)}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((logList) => (
                                <tr
                                    key={logList.uuid}
                                    style={{ width: '264px' }}
                                >
                                    <td className=""></td>
                                    {keys.map((key) => {
                                        const value =
                                            logList[key as keyof AuditLog];

                                        return (
                                            <td
                                                key={key}
                                                className="cursor-pointer"
                                                onClick={() =>
                                                    handleRowClick(logList)
                                                }
                                            >
                                                <div
                                                    className={`text-base font-normal text-table_header`}
                                                >
                                                    {value ?? 'N/A'}
                                                </div>
                                            </td>
                                        );
                                    })}
                                    {/* <td>
                                        <div className="text-center">
                                            <div
                                                className="cursor-pointer btn text-white bg-primary py-2 px-3"
                                                onClick={() =>
                                                    handleViewClick(logList)
                                                }
                                            >
                                                {t('device_details.view')}
                                            </div>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                            <tr></tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <DeviceDetailsModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );
};
export default AuditLogDisplay;
